import moment from 'moment'

const dateFilter = function (value, format = 'DD.MM.YYYY') {
  return moment(value).format(format)
};

export default dateFilter
